const MENU = [
  {
    path: "/deviceInfo-manage",
    name: "/deviceInfo-manage",
    icon: "v-icon-image",
    img: require('@/assets/img/terminal.svg'),
    title: "设备管理",
    component: () =>
      import( /* webpackChunkName: "deviceInfo-manage" */ "@/views/index.vue"),
    redirect: () => {
      return {
        name: '/deviceInfo-manage/product'
      }
    },
    children: [
      {
        path: "product",
        name: "/deviceInfo-manage/product",
        title: "产品",
        redirect: () => {
          return {
            name: '/deviceInfo-manage/product-list-info'
          }
        },
        component: () =>
          import( /* webpackChunkName: "product-index" */ "@/views/deviceInfo-manage/product/index.vue"),
        children: [{
            path: "list-info",
            name: "/deviceInfo-manage/product-list-info",
            component: () =>
              import( /* webpackChunkName: "product-list-info" */ "@/views/deviceInfo-manage/product/list-info.vue"),
          },
          {
            path: "details-info",
            name: "/deviceInfo-manage/product-details-info",
            component: () =>
              import( /* webpackChunkName: "product-details-info" */ "@/views/deviceInfo-manage/product/details-info.vue"),
          },
          {
            path: "draft-list",
            name: "/deviceInfo-manage/product-draft-list",
            component: () =>
              import( /* webpackChunkName: "product-draft-list" */ "@/views/deviceInfo-manage/product/draft-list.vue"),
          }
        ]
      },
      {
        path: "device",
        name: "/deviceInfo-manage/device",
        title: "设备",
        redirect: () => {
          return {
            name: '/deviceInfo-manage/device-list-info'
          }
        },
        component: () =>
          import( /* webpackChunkName: "device-index" */ "@/views/deviceInfo-manage/device/index.vue"),
        children: [{
            path: "list-info",
            name: "/deviceInfo-manage/device-list-info",
            component: () =>
              import( /* webpackChunkName: "device-list-info" */ "@/views/deviceInfo-manage/device/list-info.vue"),
          },
          {
            path: "list-info-child",
            name: "/deviceInfo-manage/device-list-info-child",
            component: () =>
              import( /* webpackChunkName: "device-list-info" */ "@/views/deviceInfo-manage/device/list-info-child.vue"),
          },
          {
            path: "details-info",
            name: "/deviceInfo-manage/device-details-info",
            component: () =>
              import( /* webpackChunkName: "device-details-info" */ "@/views/deviceInfo-manage/device/details-info.vue"),
          }]
      },
      {
        path: "subgroup",
        name: "/deviceInfo-manage/subgroup",
        title: "分组",
        redirect: () => {
          return {
            name: '/deviceInfo-manage/subgroup-list-info'
          }
        },
        component: () =>
          import( /* webpackChunkName: "subgroup-index" */ "@/views/deviceInfo-manage/subgroup/index.vue"),
        children: [{
            path: "list-info",
            name: "/deviceInfo-manage/subgroup-list-info",
            component: () =>
              import( /* webpackChunkName: "subgroup-list-info" */ "@/views/deviceInfo-manage/subgroup/list-info.vue"),
          },
          {
            path: "details-info",
            name: "/deviceInfo-manage/subgroup-details-info",
            component: () =>
              import( /* webpackChunkName: "subgroup-details-info" */ "@/views/deviceInfo-manage/subgroup/details-info.vue"),
          }]
      }
    ]
  },
  {
    path: "/monitoring-operation",
    name: "/monitoring-operation",
    icon: "icon-refresh",
    img: require('@/assets/img/fast.svg'),
    title: "监控运维",
    component: () =>
      import( /* webpackChunkName: "monitoring-operation" */ "@/views/index.vue"),
    redirect: () => {
      return {
        name: '/monitoring-operation/policy-set'
      }
    },
    children: [
      {
        path: "policy-set",
        name: "/monitoring-operation/policy-set",
        title: "定向升级",
        component: () =>
          import( /* webpackChunkName: "policy-set" */ "@/views/monitoring-operation/policy-set.vue"),
      },
      {
        path: "force-upgrade",
        name: "/monitoring-operation/force-upgrade",
        title: "强制升级",
        component: () =>
          import( /* webpackChunkName: "force-upgrade" */ "@/views/monitoring-operation/force-upgrade.vue"),
      },
      {
        path: "version-list",
        name: "/monitoring-operation/version-list",
        title: "版本列表",
        component: () =>
          import( /* webpackChunkName: "version-list" */ "@/views/monitoring-operation/version-list.vue"),
      },
      {
        path: "log-service",
        name: "/monitoring-operation/log-service",
        title: "日志服务",
        component: () =>
          import( /* webpackChunkName: "log-service" */ "@/views/monitoring-operation/log-service.vue"),
      },
    ]
  },
  {
    path: "/message-forwarding",
    name: "/message-forwarding",
    icon: "icon-router",
    img: require('@/assets/img/file-exception.svg'),
    title: "消息转发",
    component: () =>
      import( /* webpackChunkName: "message-forwarding" */ "@/views/index.vue"),
    redirect: () => {
      return {
        name: '/message-forwarding/rule-engine'
      }
    },
    children: [{
      path: "rule-engine",
      name: "/message-forwarding/ruleEngine",
      title: "规则引擎",
      redirect: () => {
        return {
          name: '/message-forwarding/rule-engine'
        }
      },
      component: () =>
        import( /* webpackChunkName: "rule-engine-index" */ "@/views/message-forwarding/index.vue"),
        children: [{
          path: "rule-engine",
          name: "/message-forwarding/rule-engine",
          component: () =>
            import( /* webpackChunkName: "rule-engine" */ "@/views/message-forwarding/rule-engine.vue"),
        },
        {
          path: "topic-list",
          name: "/message-forwarding/topic-list",
          component: () =>
            import( /* webpackChunkName: "topic-list-info" */ "@/views/message-forwarding/topic-list.vue"),
        }]
    }, ]
  },
  {
    path: "/common-physical-model",
    name: "/common-physical-model",
    icon: "icon-router",
    img: require('@/assets/img/function-list.svg'),
    title: "公共物模型",
    component: () =>
      import( /* webpackChunkName: "common-physical-model" */ "@/views/common-physical-model/index.vue"),
    redirect: () => {
      return {
        name: '/common-physical-model/draft-list'
      }
    },
    children: [
      {
        path: 'draft-list',
        name: '/common-physical-model/draft-list',
        title: "公共物模型",
        component: () =>
          import( /* webpackChunkName: "draft-list" */ "@/views/common-physical-model/draft-list.vue"),
      }
    ]
  }
];

export {
  MENU
};